// Service de traduction instantanée (FR <-> ZH)
// Utilise l'API de traduction rapide sans clé requise, avec cache en mémoire

const translationCache = new Map();

/**
 * Traduit un texte vers la langue cible
 * @param {string} text - Texte à traduire
 * @param {string} targetLang - Langue cible ('zh-CN' ou 'fr')
 * @param {string} sourceLang - Langue source ('auto', 'fr', ou 'zh-CN')
 * @returns {Promise<string>} - Texte traduit ou texte original en cas d'échec
 */
export const translateText = async (text, targetLang = 'zh-CN', sourceLang = 'auto') => {
    if (!text || typeof text !== 'string' || !text.trim()) {
        return text;
    }

    const trimmed = text.trim();
    const cacheKey = `${sourceLang}_${targetLang}_${trimmed}`;

    if (translationCache.has(cacheKey)) {
        return translationCache.get(cacheKey);
    }

    try {
        const url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=${encodeURIComponent(sourceLang)}&tl=${encodeURIComponent(targetLang)}&dt=t&q=${encodeURIComponent(trimmed)}`;
        
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`HTTP error ${response.status}`);
        }

        const data = await response.json();
        // data[0] contient un tableau de segments [[traduction, original], ...]
        if (Array.isArray(data) && Array.isArray(data[0])) {
            const translated = data[0].map(segment => segment[0]).join('');
            if (translated) {
                translationCache.set(cacheKey, translated);
                return translated;
            }
        }
        return trimmed;
    } catch (error) {
        console.warn('Erreur lors de la traduction:', error);
        return trimmed; // En cas de problème réseau, renvoyer le texte original sans bloquer l'UI
    }
};

export default {
    translateText
};
